import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import localforage from 'localforage'

// Configure localforage to prefer localStorage over IndexedDB
// iOS Safari aggressively clears IndexedDB but is more reliable with localStorage
localforage.config({
    driver: [
        localforage.LOCALSTORAGE,
        localforage.INDEXEDDB,
        localforage.WEBSQL
    ],
    name: 'tm-patient-registration'
})

// Backup key for localStorage fallback
const BACKUP_STORAGE_KEY = 'tm_registration_backup'

const vuexLocal = new VuexPersistence({
    storage: localforage,
    asyncStorage: true,
    // Custom save that also backs up to localStorage
    saveState: (key, state, storage) => {
        // Save to localforage
        storage.setItem(key, state)
        // Also backup critical registration data to localStorage directly
        try {
            if (state && state.registration && state.registration.data) {
                const data = state.registration.data
                // Only backup if we have meaningful data (not just photos)
                if (data.name_first || data.phone_phone || data.date_of_birth) {
                    localStorage.setItem(BACKUP_STORAGE_KEY, JSON.stringify(state.registration.data))
                }
            }
        } catch (e) {
            console.warn('Failed to backup to localStorage:', e)
        }
    },
    // Custom restore that checks localStorage backup if localforage is empty
    restoreState: async (key, storage) => {
        try {
            let state = await storage.getItem(key)
            
            // Check if registration data is missing or empty
            const hasRegistrationData = state && 
                state.registration && 
                state.registration.data && 
                Object.keys(state.registration.data).length > 0 &&
                (state.registration.data.name_first || state.registration.data.phone_phone)
            
            if (!hasRegistrationData) {
                // Try to restore from localStorage backup
                const backup = localStorage.getItem(BACKUP_STORAGE_KEY)
                if (backup) {
                    try {
                        const backupData = JSON.parse(backup)
                        console.log('Restoring from localStorage backup')
                        if (!state) {
                            state = { registration: { data: {} } }
                        }
                        if (!state.registration) {
                            state.registration = { data: {} }
                        }
                        state.registration.data = backupData
                    } catch (e) {
                        console.warn('Failed to parse localStorage backup:', e)
                    }
                }
            }
            
            return state
        } catch (e) {
            console.error('Error restoring state:', e)
            // Try localStorage backup as last resort
            const backup = localStorage.getItem(BACKUP_STORAGE_KEY)
            if (backup) {
                try {
                    return { registration: { data: JSON.parse(backup) } }
                } catch (parseError) {
                    console.warn('Failed to parse localStorage backup:', parseError)
                }
            }
            return null
        }
    }
})

import registration from "./modules/registration"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        registration
    },
    plugins: [vuexLocal.plugin],
    strict: true
})
